import React, { useEffect, useState } from 'react';
import { Snowflake, CloudRain, X } from 'lucide-react';
import api from '../lib/api';

const DISMISS_KEY = 'sm_weather_alert_dismissed';

export const WeatherAlertBanner = () => {
  const [ev, setEv] = useState(null);

  useEffect(() => {
    let timer;
    const load = async () => {
      try {
        const { data } = await api.get('/weather/alert');
        const e = data?.event;
        if (!e) { setEv(null); return; }
        const today = new Date().toISOString().slice(0, 10);
        const soon = e.day <= today || (new Date(e.starts_at) - new Date()) / 36e5 <= 24;
        setEv(soon && localStorage.getItem(DISMISS_KEY) !== `${e.day}:${e.kind}` ? e : null);
      } catch (err) { /* faixa silenciosa */ }
    };
    load();
    timer = setInterval(load, 30 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  if (!ev) return null;
  const snow = ev.kind === 'snow';
  const Icon = snow ? Snowflake : CloudRain;
  const when = `${ev.starts_at.slice(8, 10)}/${ev.starts_at.slice(5, 7)} às ${ev.starts_at.slice(11, 16)}`;
  const volume = snow && ev.snowfall_cm ? ` · ${ev.snowfall_cm}cm` : (ev.precip_mm ? ` · ${ev.precip_mm}mm` : '');

  return (
    <div data-testid="weather-alert-banner"
      className={`flex items-center gap-2.5 px-3 py-2 border-b ${snow ? 'border-sky-300/30 bg-sky-300/10' : 'border-amber-400/30 bg-amber-400/10'}`}>
      <Icon className={`w-4 h-4 shrink-0 ${snow ? 'text-sky-200' : 'text-amber-300'} ${snow ? 'wx-flake-spin' : ''}`} />
      <p className="text-[12px] leading-tight flex-1">
        <b className="font-bold uppercase tracking-wide text-[11px] mr-1.5">{snow ? 'Neve chegando' : 'Chuva forte chegando'}</b>
        <span className="text-foreground/80">{ev.label} a partir de {when}{volume} — reveja entregas, test drives e lavagens do dia.</span>
      </p>
      <button data-testid="weather-alert-dismiss" title="Ocultar hoje"
        onClick={() => { localStorage.setItem(DISMISS_KEY, `${ev.day}:${ev.kind}`); setEv(null); }}
        className="shrink-0 p-1 rounded hover:bg-foreground/10 transition-colors"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
};
